import { AnimationProps } from 'framer-motion'
import { isMobile } from '@flowwai-frontend/shared/utils/web'

export const getIsActiveViewStyle = (isSelected: boolean) => `
   flex flex-col gap-3 
   rounded-xl relative cursor-pointer shrink-0
   active:scale-95 transition
   ${
      isSelected
         ? 'outline outline-2 outline-primary-600 outline-offset-[-2px]'
         : 'shadow'
   }
`

export const kmlTriggerButton =
   'flex items-center gap-1 cursor-pointer p-2 rounded-[200px] hover:bg-gray-50'

export const toolButtonText = 'text-gray-700 text-sm-semibold'

export const toggleContainer =
   'p-1 bg-gray-100 rounded-xl border border-gray-200 flex items-center gap-1 cursor-pointer'

export const toggleItem =
   'px-2 py-1 rounded-lg flex justify-center items-center active:scale-95 transition-all'

export const activeToggleItem = 'bg-white shadow'

export const currentLocationMarkerOuterCircle =
   'rounded-full w-[52px] h-[52px] bg-opacity-30 p-4 bg-primary-400'

export const currentLocationMarkerInnerCircle =
   'rounded-full w-full h-full border-2 border-base-white bg-primary-600'

// #region - Mark Location Tooltip
export const markLocationPopup = `
   relative
   flex flex-col gap-2 items-center
   px-2 pt-2 pb-3 
   bg-white 
   rounded-xl 
`

export const markLocationPopupImage = 'w-96 h-68 rounded-md object-cover'

export const markLocationPopupHelpText = 'text-gray-700 text-xs-medium'

export const markLocationPopupAnchor = `
   absolute 
   left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2 rotate-45
   w-2 h-2 
   bg-base-white  
`
// #endregion - Mark Location Tooltip

// #region - Places Search Tool
export const placesSearchCustomOption =
   'p-[10px] flex flex-row items-center gap-1 cursor-pointer hover:bg-gray-100 rounded-2xl mb-2 truncate w-full '

export const placesSearchOptionText =
   'w-full truncate text-sm-medium text-gray-900'
// #endregion - Places Search Tool

// #region - Close Maps
export const closeIconButtonStyles =
   'p-3 rounded-full bg-[#fffc] backdrop-blur-sm cursor-pointer shadow-lg'

export const mobileCloseIconContainerStyles =
   'px-4 py-3 border-b border-gray-300'

export const closeIconAnimationProps: AnimationProps = isMobile()
   ? {}
   : {
        initial: { x: 60, opacity: 0 },
        animate: { x: 0, opacity: 1 },
        transition: {
           type: 'spring',
           stiffness: 260,
           damping: 24,
           delay: 0.3
        }
     }

// #endregion - Close Maps
